var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import Register from "./components/Pages/Register";
import EventList from "./components/Pages/EventList";
import AppErrorPage from "./AppErrorPage";
import { useCookies } from "react-cookie";
import { updateKiosk } from "./store/Utilities/actions";
import AuthResult from "./components/Pages/AuthResult/AuthResult";
import LoaderPage from "./components/Pages/LoaderPage";
import Constants from "./data/constants";
import CookieWarning from "./components/Pages/CookieWarning/CookieWarning";
import Oops from "./components/Pages/Oops/Oops";
import Lookup from "./components/Pages/Lookup/Lookup";
import { DotsLoader, Loader, Well } from "@brushfire/ui";
import FullWell from "./components/UI/FullWell/FullWell";
import Profile from "./components/Pages/Profile/Profile";
import { WidgetContext } from "./components/Widget";
import Receipt from "./components/Pages/Receipt/Receipt";
import Calendar from "./components/Pages/Calendar/Calendar";
import EventMap from "./components/Pages/EventList/EventMap";
import Tix from "./components/Pages/Tix/Tix";
import axios from "axios";
import { BF_QUEUE_ID } from "./EntryQueue";
var useTypedSelector = useSelector;
var AppRoutes = function (_a) {
    var theme = _a.theme, isWidget = _a.isWidget, allowAccess = _a.allowAccess;
    var _b = useTypedSelector(function (store) { return store.app; }), pageError = _b.pageError, globalLoaders = _b.globalLoaders;
    var lookups = useTypedSelector(function (store) { return store.postAttendeeActions; }).lookups;
    var _c = useTypedSelector(function (store) { return store.accounts; }), customerAccount = _c.customerAccount, account = _c.account;
    var clientKey = window.location.pathname.split("/")[1];
    var localUUID = localStorage.getItem(BF_QUEUE_ID);
    var _d = __read(useCookies([
        Constants.Cookies.KIOSK,
        Constants.Cookies.KIOSK_LAYOUT,
        Constants.Cookies.KIOSK_HOMEURL,
    ]), 1), cookies = _d[0];
    var dispatch = useDispatch();
    var setShowGlobalLoader = useContext(WidgetContext).setShowGlobalLoader;
    var createPresence = function (payload) {
        var widgetSourceClient = axios.create({
            baseURL: process.env.REACT_APP_BF_ENV === "staging" || process.env.REACT_APP_BF_ENV === "future"
                ? "https://apistaging-st3i2yb5oq-uc.a.run.app"
                : "https://apigen2-st3i2yb5oq-uc.a.run.app",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        widgetSourceClient.post("/attendees", payload).then(function (_a) {
            var data = _a.data;
            if (data.success !== true) {
                console.error("Something went wrong while updating your session");
            }
        });
    };
    useEffect(function () {
        var _a, _b;
        //console.log("mmm", account?.Id, previousAccountId, localUUID);
        //@ts-expect-error it's a Pascal dotnet thing
        if ((account === null || account === void 0 ? void 0 : account.Id) && localUUID) {
            //Update the queue presence to reflect the new account id
            createPresence({
                uid: localUUID,
                clientKey: clientKey,
                path: window.location.pathname,
                ua: window.navigator.userAgent,
                forceQueue: false,
                v: (_b = (_a = document.getElementById("brushfire")) === null || _a === void 0 ? void 0 : _a.getAttribute("src")) !== null && _b !== void 0 ? _b : "",
                wid: "x",
                //@ts-expect-error it's a Pascal dotnet thing
                aid: account.Id,
                isUser: true,
            });
        }
        //@ts-expect-error it's a Pascal dotnet thing
    }, [account === null || account === void 0 ? void 0 : account.Id, localUUID]);
    useEffect(function () {
        var _a, _b;
        if ((customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.id) && localUUID) {
            //Update the queue presence to reflect the new customer account id
            createPresence({
                uid: localUUID,
                clientKey: clientKey,
                path: window.location.pathname,
                ua: window.navigator.userAgent,
                forceQueue: false,
                v: (_b = (_a = document.getElementById("brushfire")) === null || _a === void 0 ? void 0 : _a.getAttribute("src")) !== null && _b !== void 0 ? _b : "",
                wid: "x",
                cid: customerAccount.id,
                isCustomer: true,
            });
        }
    }, [customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.id, localUUID]);
    useEffect(function () {
        if (cookies[Constants.Cookies.KIOSK] === "True") {
            dispatch(updateKiosk({
                enabled: cookies[Constants.Cookies.KIOSK] === "True",
                layout: cookies[Constants.Cookies.KIOSK_LAYOUT],
                homeUrl: cookies[Constants.Cookies.KIOSK_HOMEURL],
            }));
        }
        else {
            dispatch(updateKiosk({
                enabled: false,
                layout: "",
                homeUrl: "",
            }));
        }
    }, [cookies]);
    var showLoader = Object.values(globalLoaders).some(function (l) { return l === true; });
    useEffect(function () {
        setShowGlobalLoader(showLoader);
    }, [showLoader]);
    return (_jsx(_Fragment, { children: pageError ? (_jsx(AppErrorPage, { pageError: pageError })) : (_jsxs(_Fragment, { children: [showLoader && (_jsx(Loader, { customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader" })), allowAccess && (_jsx("div", __assign({ className: showLoader ? "invisible" : "" }, { children: _jsxs(Switch, { children: [_jsx(Route, { path: "/loading", render: function (props) { return _jsx(LoaderPage, {}); } }), _jsx(Route, { path: "/authResult", render: function (props) { return _jsx(AuthResult, __assign({}, props, { theme: theme, isWidget: isWidget })); } }), _jsx(Route, { path: "/cookies", render: function (props) { return _jsx(CookieWarning, {}); } }), _jsx(Route, { path: "/oops", render: function (props) { return _jsx(Oops, {}); } }), _jsx(Route, { path: Constants.Routes.profile, render: function (props) { return (_jsx(FullWell, __assign({ isWidget: isWidget }, { children: _jsx(Profile, __assign({}, props, { path: props.match.path, isWidget: isWidget })) }))); } }), _jsx(Route, { path: Constants.Routes.myOrderReceipt, render: function (props) { return (_jsx(Receipt, __assign({}, props, { path: props.match.path, isWidget: isWidget }))); } }), _jsx(Route, { path: Constants.Routes.tix, render: function () { return _jsx(Tix, { isWidget: isWidget }); } }), _jsx(Route, { path: Constants.Routes.lookup, render: function (props) {
                                    var _a, _b, _c, _d;
                                    if ((props.match.params.lookupId || (customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.email)) &&
                                        (!(lookups === null || lookups === void 0 ? void 0 : lookups.status.isLoaded) ||
                                            ((_b = (_a = lookups === null || lookups === void 0 ? void 0 : lookups.myEvents) === null || _a === void 0 ? void 0 : _a.upcoming) === null || _b === void 0 ? void 0 : _b.length) ||
                                            ((_d = (_c = lookups === null || lookups === void 0 ? void 0 : lookups.myEvents) === null || _c === void 0 ? void 0 : _c.upcoming) === null || _d === void 0 ? void 0 : _d.length))) {
                                        return (_jsx(FullWell, __assign({ isWidget: isWidget }, { children: _jsx(Lookup, __assign({}, props, { path: props.match.path, isWidget: isWidget })) })));
                                    }
                                    else {
                                        if (customerAccount) {
                                            return (_jsx(Well, __assign({ className: "ta-left well-md m-top-large lookup-well" }, { children: _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "account-hero lookup-hero" }, { children: "Access your events" })), _jsx("div", __assign({ className: "lookup-form-wrap" }, { children: _jsx(Lookup, __assign({}, props, { path: props.match.path, isWidget: isWidget })) }))] }) })));
                                        }
                                        else {
                                            return (_jsx(Lookup, __assign({}, props, { path: props.match.path, isWidget: isWidget })));
                                        }
                                    }
                                } }), _jsx(Route, { path: Constants.Routes.calendar, render: function (props) { return _jsx(Calendar, __assign({}, props, { theme: theme, isWidget: isWidget })); } }), _jsx(Route, { path: Constants.Routes.map, render: function (props) { return _jsx(EventMap, __assign({}, props, { theme: theme, isWidget: isWidget })); } }), _jsx(Route, { path: [
                                    Constants.Routes.myDashboard,
                                    Constants.Routes.myAttendee,
                                    Constants.Routes.details,
                                    Constants.Routes.register,
                                    Constants.Routes.tickets,
                                    Constants.Routes.section,
                                    Constants.Routes.questions,
                                    Constants.Routes.addons,
                                    Constants.Routes.cart,
                                    Constants.Routes.checkout,
                                    Constants.Routes.results,
                                    Constants.Routes.resetGroup,
                                    Constants.Routes.autoreg,
                                    Constants.Routes.autogroup,
                                    Constants.Routes.signature,
                                    Constants.Routes.emailDirections,
                                    Constants.Routes.eventStart,
                                ], render: function (props) { return (_jsx(Register, __assign({}, props, { path: props.match.path, theme: theme, isWidget: isWidget }))); } }), _jsx(Route, { path: Constants.Routes.eventList, render: function (props) { return _jsx(EventList, __assign({}, props, { theme: theme, isWidget: isWidget })); } }), _jsx(Route, { path: "*", component: function (_a) {
                                    var staticContext = _a.staticContext;
                                    if (staticContext)
                                        staticContext.status = 404;
                                    return _jsx("h1", { children: "Not Found :(" });
                                } })] }) })))] })) }));
};
export default AppRoutes;
